import { useOnMockReactionsCreatedSubscription } from '@/generated/graphql';
import { useOnReactionsCreatedSubscription } from '@/generated/graphql';
import styles from './StageReactions.module.css';
import { StageReactionFragment } from '@/generated/graphql';
import { useEffect, useRef, useState } from 'react';
import { useMockRealtimeChannel } from '@/hooks/useMockRealtimeChannel';

export function StageReactions({ submissionId }: { submissionId: string }) {
  const [visibleReactions, setVisibleReactions] = useState<
    { reaction: StageReactionFragment; leftStart: string }[]
  >([]);

  const timers = useRef<NodeJS.Timeout[]>([]);

  const mockRealtime = useMockRealtimeChannel();

  const onReactions = (reactions: StageReactionFragment[] | undefined) => {
    if (!reactions?.length) {
      return;
    }
    const reactionIds = reactions.map((r) => r.id);
    setVisibleReactions((prev) => [
      ...prev,
      ...reactions.map((reaction) => ({
        reaction,
        leftStart: `${Math.random() * 50 + 5}%`,
      })),
    ]);
    timers.current.push(
      setTimeout(() => {
        setVisibleReactions((prev) =>
          prev.filter((r) => !reactionIds.includes(r.reaction.id)),
        );
      }, 5000),
    );
  };

  useOnReactionsCreatedSubscription({
    variables: { submissionId },
    onData: (data) => {
      onReactions(data.data?.data?.reactionsCreated?.reactions);
    },
  });
  useOnMockReactionsCreatedSubscription({
    skip: !mockRealtime,
    variables: { submissionId },
    onData: (data) => {
      onReactions(data.data?.data?.mockReactionsCreated?.reactions);
    },
  });

  useEffect(() => {
    const timerIds = timers.current;
    return () => {
      timerIds.forEach((timer) => clearTimeout(timer));
    };
  }, []);

  return (
    <div
      data-name="STAGE-REACTIONS"
      className="absolute top-[100vh] z-50 w-full"
    >
      {visibleReactions.map((r) => (
        <div
          className={` ${styles.floatUp} absolute top-0`}
          key={r.reaction.id}
          style={{ left: r.leftStart }}
        >
          <div className={` ${styles.jiggle} text-5xl`}>{r.reaction.type}</div>
        </div>
      ))}
    </div>
  );
}
